import { Stack, Typography } from '@mui/material';
import React from 'react';

import { DotIcon } from '@/shared/assets/icons/dot-icon';
import { ChipContainer } from '@/shared/components/ui/chip/chip.styled';
import { TChip } from '@/shared/components/ui/chip/chip.types';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';

export const Chip: React.FC<TChip> = ({
  status,
  label,
  tooltip,
  onClick,
  withDot,
  tooltipProps,
  variant = 'default',
}) => {
  const isClickable = Boolean(onClick);

  const renderLabel = () => {
    if (typeof label === 'string') {
      return (
        <Typography variant="button" textTransform="capitalize">
          {label}
        </Typography>
      );
    }

    return label;
  };

  const renderContent = () => {
    if (!withDot) {
      return renderLabel();
    }

    return (
      <Stack component="span" direction="row" gap="0.25rem" alignItems="center">
        <DotIcon className="chip-dot" />
        {renderLabel()}
      </Stack>
    );
  };

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    onClick?.(event);
  };

  return (
    <Tooltip title={tooltip} {...tooltipProps}>
      <ChipContainer
        $variant={variant}
        $clickable={isClickable}
        $status={status}
        onClick={handleClick}
      >
        {renderContent()}
      </ChipContainer>
    </Tooltip>
  );
};
